exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":host::ng-deep ngb-alert .alert-danger{max-width:1200px;margin:auto}:host legend{font-family:Perpetua;font-size:2rem}:host fieldset{width:100%}:host a{color:#005092;font-weight:600;text-decoration:underline}:host .alert.alert-warning{padding:.75rem 1.25rem;margin-top:5px}:host .identifiant,:host .notification{padding:0}.modal-content{padding:2.5rem}.modal-header{text-align:center;font-weight:900}.modal-body{margin-top:1.5rem}.my-info-modal-cancel-btn{margin-left:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/account/settings/settings.component.scss
// module id = 663
// module chunks = 0